export default __webpack_public_path__ + "static/media/host_fileShare_active.50fbb395.svg";